import {defineMessages, useIntl} from 'react-intl';
import {cancel} from '@sail/icons/react/Icon';
import {css, Icon, view} from '@sail/ui/deprecated';
import {Attachment} from './Attachment';
import {PreviewImage} from './PreviewImage';

export const messages = defineMessages({
  removeButtonAriaLabel: {
    id: 'support_conversations_client.attachments.removeButton.ariaLabel',
    description: 'Label for button that removes attachments',
    defaultMessage: 'Remove attachment',
  },
});

type AttachmentPreviewProps = {
  attachment: Attachment;
  onRemoveAttachment: (attachment: Attachment) => void;
};

export const AttachmentPreview = ({
  attachment,
  onRemoveAttachment,
}: AttachmentPreviewProps): JSX.Element => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        display: css.value('flex'),
        alignItems: css.value('center'),
        height: css.value('$space.xxlarge'),
        width: 'fill',
      }}
    >
      <PreviewImage attachment={attachment} />
      <view.span
        css={{
          fontWeight: 'semibold',
          width: 'fill',
          marginLeft: 'small',
          marginRight: 'small',
          overflow: 'hidden',
          whiteSpace: css.value('nowrap'),
          textOverflow: css.value('ellipsis'),
        }}
      >
        {attachment.fileName}
      </view.span>
      <view.button
        aria-label={intl.formatMessage(messages.removeButtonAriaLabel)}
        onClick={() => onRemoveAttachment(attachment)}
        css={{
          border: css.value('none'),
          borderRadius: 'small',
          flexShrink: css.value(0),
          color: 'secondary',
          background: css.value('none'),
          display: css.value('flex'),
          padding: 'xsmall',
          '&:hover': {
            background: css.value('$color.neutral100'),
          },
        }}
        type={'button'}
      >
        <Icon size="xsmall" icon={cancel} data-testid="delete-icon" />
      </view.button>
    </view.div>
  );
};
